import { render } from "./ListAlt.vue?vue&type=template&id=0a87a299&scoped=true"
import script from "./ListAlt.vue?vue&type=script&lang=js"
export * from "./ListAlt.vue?vue&type=script&lang=js"

import "./ListAlt.vue?vue&type=style&index=0&id=0a87a299&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a87a299"

export default script